import { Box, FormControl, FormControlLabel, Tooltip } from '@mui/material';
import { useState } from 'react';
import { TealSwitch } from '../../Styles/AppStyles';
import apiClient from '../../Services/ApiClient';
import { MultiSelect } from '../../Components/Checkbox/Checkbox';
import {
  Form,
  FormSection,
  SectionTitle,
  SectionDescription,
  FormGrid,
  FormTextField,
} from '../../Components/Form';

export const EmailForm = ({ onSubmit, onCancel, defaultValues = {}, availableRoles = [] }: any) => {
  const [formData, setFormData] = useState({
    name: defaultValues.name || '',
    description: defaultValues.description || '',
    unique_name: defaultValues.unique_name || '',
    active_flag:
      defaultValues.active_flag !== undefined ? defaultValues.active_flag : 1,
    roles: typeof defaultValues.role_ids === 'string'
      ? defaultValues.role_ids.split(',').map((id: string) => parseInt(id.trim(), 10))
      : defaultValues.roles || [],
  });

  const [errors] = useState<any>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleToggleChange = async () => {
    const updatedFormData = {
      ...formData,
      active_flag: formData.active_flag ? 0 : 1,
    };

    setFormData(updatedFormData);

    const response = await apiClient(`/api/emails/subscriptions/${defaultValues.id}/admin`, {
      method: 'PUT',
      body: JSON.stringify(updatedFormData),
    });

    if (!response.ok) {
      setFormData({
        ...formData,
        active_flag: formData.active_flag,
      });
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (Object.keys(errors).length === 0) {
      onSubmit(formData);
    }
  };

  return (
    <Form
      embedded
      hideTitle
      onSubmit={handleSubmit}
      title={defaultValues?.id ? 'Edit Email Subscription' : 'Add Email Subscription'}
      subtitle="Configure email subscription details and role access."
      submitLabel="Submit"
      onCancel={onCancel}
      disableSubmit={Object.keys(errors).length > 0}
    >
      <FormSection>
        <SectionTitle>Subscription Details</SectionTitle>
        <SectionDescription>Basic information for this email subscription.</SectionDescription>
        <FormGrid $columns={1}>
          <FormTextField
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name || ''}
            required
          />
          <FormTextField
            label="Unique Name"
            name="unique_name"
            required
            value={formData.unique_name}
            onChange={handleChange}
            error={!!errors.unique_name}
            helperText={errors.unique_name || ''}
          />
          <FormTextField
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            multiline
            rows={4}
          />
        </FormGrid>
      </FormSection>

      <FormSection>
        <SectionTitle>Role Access</SectionTitle>
        <SectionDescription>Select which roles receive this subscription.</SectionDescription>
        <MultiSelect
          title="Choose Roles"
          items={availableRoles}
          selectedItems={formData.roles}
          setSelectedItems={(selected: number[]) => setFormData({ ...formData, roles: selected })}
        />
      </FormSection>

      <FormSection>
        <Box display="flex" alignItems="center" gap={1}>
          <Tooltip title="Toggle to activate or deactivate this email subscription" arrow>
            <FormControl component="fieldset">
              <FormControlLabel
                control={
                  <TealSwitch
                    checked={!!formData.active_flag}
                    onChange={handleToggleChange}
                    color="primary"
                  />
                }
                label="Active"
              />
            </FormControl>
          </Tooltip>
        </Box>
      </FormSection>
    </Form>
  );
};
